import { List, Map } from 'immutable';
import {
  types as buildsTypes,
  records as buildsRecords,
} from '@saucelabs/sl-module-builds';
import {
  constants as jobsConstants,
  records as jobsRecords,
  types as jobsTypes,
} from '@saucelabs/sl-module-jobs';

import * as types from './types';
import { types as filterTypes } from './../filters';
import {
  DEFAULT_CLOUD_TYPE,
  INITIAL_RDC_OFFSET,
  LS_LAST_CLOUD_TYPE,
} from './constants';

const initialState = new Map({
  automated: new List(),
  builds: new List(),
  cloudType: window.localStorage.getItem(LS_LAST_CLOUD_TYPE) || DEFAULT_CLOUD_TYPE,
  manual: new List(),
  rdc: new List(),
  rdcError: {},
  rdcMoreAvailable: false,
  rdcOffset: INITIAL_RDC_OFFSET,
  // loaders
  automatedLoading: true,
  buildsLoading: true,
  manualLoading: true,
  rdcLoading: true,
  filtersInitialized: false,
  // additional needed data
  orgUsers: new List(),
  orgTeams: new List(),
});


const toggleLoader = (mutable, turnOnLoader = true) => (
  mutable
    .set('automatedLoading', turnOnLoader)
    .set('buildsLoading', turnOnLoader)
    .set('manualLoading', turnOnLoader)
    .set('rdcLoading', turnOnLoader)
);

const jobsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case buildsTypes.BUILDS_GET.SUCCESS: {
      const builds = payload.map((build) => (
        new buildsRecords.BuildRecord({
          ...build,
          status: build.status || 'new',
        })
      ));
      return state.withMutations((mutable) => (
        mutable
          .set('builds', new List(builds))
          .set('buildsLoading', false)
      ));
    }
    case jobsTypes.JOBS_GET.SUCCESS:
    case jobsTypes.AUTOMATED_JOBS_GET.SUCCESS: {
      const jobs = payload.jobs.map((job) => new jobsRecords.JobRecord(job));
      return state.withMutations((mutable) => (
        mutable
          .set('automated', new List(jobs))
          .set('automatedLoading', false)
      ));
    }
    case jobsTypes.UP_JOBS_GET.REQUEST:
      return state.set('rdcError', initialState.get('rdcError'));
    case jobsTypes.UP_JOBS_GET.SUCCESS: {
      const jobs = payload.entities.map((job) => new jobsRecords.RdcJobRecord(job));
      return state.withMutations((mutable) => (
        mutable
          .set('rdc', new List(jobs))
          .set('rdcLoading', false)
          .set('rdcMoreAvailable', payload.metaData.moreAvailable)
      ));
    }
    case jobsTypes.MANUAL_JOBS_GET.SUCCESS: {
      const jobs = payload.jobs.map((job) => new jobsRecords.JobRecord(job));
      return state.withMutations((mutable) => (
        mutable
          .set('manual', new List(jobs))
          .set('manualLoading', false)
      ));
    }
    case types.INITIALIZE_FILTERS:
      return state.set('filtersInitialized', true);
    case types.GET_ORG_USERS.SUCCESS:
      return state.set('orgUsers', new List(payload.users));
    case types.TEAMLIST_GET.SUCCESS:
      return state.set('orgTeams', new List(payload.results));
    case types.DECREASE_RDC_OFFSET:
      return state.withMutations((mutable) => {
        mutable.set('rdcOffset', state.get('rdcOffset') - jobsConstants.QUERY_LIMIT);
        toggleLoader(mutable, true);
      });
    case types.INCREASE_RDC_OFFSET:
      return state.withMutations((mutable) => {
        mutable.set('rdcOffset', state.get('rdcOffset') + jobsConstants.QUERY_LIMIT);
        toggleLoader(mutable, true);
      });
    case types.CLEAR_RDC_OFFSET:
      return state.withMutations((mutable) => {
        mutable.set('rdcOffset', initialState.get('rdcOffset'));
        toggleLoader(mutable, true);
      });
    case types.SET_CLOUD_TYPE: {
      window.localStorage.setItem(LS_LAST_CLOUD_TYPE, payload);
      return state.set('cloudType', payload);
    }
    case jobsTypes.UP_JOBS_GET.FAILURE: {
      const { response: { data: serverMessage, status: code } } = payload;
      return state.withMutations((mutable) => {
        mutable.set('rdcError', { code, serverMessage });
        mutable.set('rdcLoading', false);
      });
    }
    case filterTypes.TOGGLE_STATUS:
    case filterTypes.SELECT_OWNER:
    case filterTypes.CLEAR_OWNER:
    case filterTypes.CLEAR_STATUSES: {
      return state.withMutations((mutable) => toggleLoader(mutable));
    }
    default:
      return state;
  }
};

export default jobsReducer;
